export const FSSAI_MODAL_KEY = 'fssaiExpiryModalDismissed'
export const licenseTypes = [
  {
    type: 'FSSAI',
    titleKeyExpire: 'fssai.modal.fssaiExpireOn',
    titleDefaultExpire: 'Your FSSAI license will expire on',
    expiredMessageKey: 'fssai.modal.expiredMessage',
    expiredMessageDefault:
      'Your FSSAI license has expired. Until you update your FSSAI details, purchases of Pharmanex products will be limited to 5 units per SKU per month for personal use, and commission payouts will be temporarily paused. Please visit Profile to make your updates.',
    renewalTextKey: 'fssai.modal.fssaiRenewalText',
    renewalTextDefault:
      'Please renew or update your license before this date to continue selling food and nutritional products without interruption.',
    consequencesTitleKey: 'fssai.modal.fssaiConsequencesTitle',
    consequencesTitleDefault:
      'If your license is not updated before it expires:',
  },
  {
    type: 'Ack-FSSAI',
    titleKeyExpire: 'fssai.modal.ackExpireOn',
    titleDefaultExpire: 'Your FSSAI Acknowledgement number will expire soon.',
    expiredMessageKey: 'fssai.modal.ackExpiredMessage',
    expiredMessageDefault:
      'Your FSSAI Acknowledgement has expired. Until you update your license details, purchases of Pharmanex products will be limited to 5 units per SKU per month for personal use, and commission payouts will be temporarily paused. Please visit Profile to make your updates.',
    renewalTextKey: 'fssai.modal.ackRenewalText',
    renewalTextDefault:
      'Please renew or update your license to continue selling food and nutritional products without interruption.',
    consequencesTitleKey: 'fssai.modal.ackConsequencesTitle',
    consequencesTitleDefault:
      'If your license is not updated before it expires:',
  },
  {
    type: 'none',
    titleKeyExpire: 'fssai.modal.noneExpireOn',
    titleDefaultExpire: 'You are required to provide an FSSAI license.',
    expiredMessageKey: 'fssai.modal.noneExpiredMessage',
    expiredMessageDefault:
      'You have not updated your FSSAI number. Until you update your license details, purchases of Pharmanex products will be limited to 5 units per SKU per month for personal use, and commission payouts will be temporarily paused. Please visit Profile to make your updates.',
    renewalTextKey: 'fssai.modal.noneRenewalText',
    renewalTextDefault:
      'Please renew or update your license to continue selling food and nutritional products without interruption.',
    consequencesTitleKey: 'fssai.modal.noneConsequencesTitle',
    consequencesTitleDefault: 'If your license is not updated:',
  },
]
